var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { Col as Component } from './Layout.styled';
import { getAutomation, getDebug } from '@citrus/runtime';
import { isNotNilOrEmpty, last, removeKeys } from '@pcty/utils';
var VERSION = '6.7.2';
var sizes = ['lg', 'md', 'sm', 'xs'];
var Col = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, children = _a.children, className = _a.className, css = _a.css, margin = _a.margin, padding = _a.padding, __TYPE = _a.__TYPE, other = __rest(_a, ["automationId", "children", "className", "css", "margin", "padding", "__TYPE"]);
    var prefix = 'pcty-col';
    var spans = [];
    var classes = [];
    sizes.forEach(function (brkPoint) {
        var _a;
        var propValue = other[brkPoint];
        var span, offset, order;
        if (isNotNilOrEmpty(propValue) && typeof propValue === 'object') {
            (_a = propValue.span, span = _a === void 0 ? true : _a, offset = propValue.offset, order = propValue.order);
        }
        else {
            span = propValue;
        }
        if (isNotNilOrEmpty(span))
            spans.push(span === true ? "".concat(prefix, "-").concat(brkPoint) : "".concat(prefix, "-").concat(brkPoint, "-").concat(span));
        if (isNotNilOrEmpty(order))
            classes.push("pcty-order-".concat(brkPoint, "-").concat(order));
        if (isNotNilOrEmpty(offset))
            classes.push("pcty-offset-".concat(brkPoint, "-").concat(offset));
    });
    if (!spans.length) {
        spans.push(prefix);
    }
    var _css = __spreadArray(__spreadArray(__spreadArray([], spans, true), classes, true), [
        margin ? 'pcty-margin-' + margin : '',
        margin && margin.indexOf('compact') >= 0 ? 'pcty-compact-margin-' + last(margin.split('-')) : '',
        padding && padding.indexOf('compact') < 0 ? 'pcty-padding-' + padding : '',
        padding && padding.indexOf('compact') >= 0 ? 'pcty-compact-padding-' + last(padding.split('-')) : '',
        className || '',
    ], false).filter(function (x) { return x.length > 0; })
        .join(' ')
        .trim();
    var _classes = cx(_css, (_b = {},
        _b[emotionCss(css)] = isNotNilOrEmpty(css),
        _b));
    return (React.createElement(Component, __assign({ className: _classes, ref: ref }, removeKeys(other, sizes), getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', __TYPE, VERSION)), children));
});
Col.defaultProps = {
    __TYPE: 'Col',
};
export default Col;
